<template>
  <div style="width: 100%; height: 98%">
    <div  class="status-container">
      <el-row>
        <el-col :span="4" :offset="1" style="text-align: left;font-size: 18px;font-weight: bold; ">
          <el-form-item label="项目年份：">
            <el-date-picker v-model="project_year" type="years" value-format="YYYY" placeholder="选择年份" @change="getBusData" style="width: 100%"/>
          </el-form-item>
        </el-col>
        <el-col :span="4" :offset="1" style="text-align: left;font-size: 18px;font-weight: bold; ">
          <el-form-item label="项目成员：">
            <el-select v-model="user_id" placeholder="请选择" clearable @change="getBusData">
              <el-option v-for="item in userList" :key="item.value" :label="item.label" :value="item.value" ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="1" :offset="2" style="text-align: right;">
          <span class="color-block pending"></span>
        </el-col>
        <el-col :span="2" style="text-align: left;">
          <span class="status-text">支出</span>
        </el-col>
        <el-col :span="1" style="text-align: right;">
          <span class="color-block processed"></span>
        </el-col>
        <el-col :span="2" style="text-align: left;">
          <span class="status-text">提成</span>
        </el-col>
      </el-row>
    </div>
    <el-row style="padding-top: 10px;overflow-y: auto;max-height: 95%;">
      <template v-for="data in busData" >
        <el-col :span="6" style="font-size: large; line-height: 50px;text-align: center;width:100%;padding:0 20px 20px 20px;margin-bottom: 15px">
          <el-row >
              <el-col :span="24" class="project-name" >{{ data.name }}</el-col>
          </el-row>
          <el-row v-for="item in data.item_list" style="width: 100%;">
            <el-col :span="12" class="val1">{{ item.name }}</el-col>
            <el-col :span="6" class="val3">{{ item.cost_amount ?? 0 }}</el-col>
            <el-col :span="6" class="val2">{{ item.bonus_amount ?? 0 }}</el-col>
          </el-row>
        </el-col>
      </template>
    </el-row>
  </div>

</template>

<script>

export default {
  name: "PrjPersonFinancial",
  data() {
    return {
      busData:[],
      project_year:[],
      userList:[],
      user_id:'',
    }
  },

  created() {
    this.getUserList();
    this.getBusData();
  },

  methods: {
    async getBusData() {
      this.busData = await this.$http('prjBoardService.getPersonFinancialData',{user_id: this.user_id,project_year: this.project_year})
    },

    async getUserList() {
      this.userList = await this.$http('prjBoardService.getUserList')
    },
  }

}

</script>

<style lang="less" scoped>

.project-name {
  margin-bottom: 5px;
  color: #fff;
  background-color: rgba(112, 110, 110, 0.44);
  font-size: 22px; /* 文字更大 */
}

.val {
  margin-bottom: 5px;
  background-color: skyblue;
  color: #fff;
}

.val1 {
  margin-bottom: 5px;
  background-color: skyblue;
  color: #fff;
}

.val2 {
  margin-bottom: 5px;
  background-color: rgba(13, 213, 46, 0.55);
  color: #fff;
}

.val3 {
  margin-bottom: 5px;
  background-color: #EA9C0BBA;
  color: #fff;
}

.val4 {
  margin-bottom: 5px;
  background-color: #FC02029D;
  color: #fff;
}

.val5 {
  margin-bottom: 5px;
  background-color: rgba(220, 216, 14, 0.71);
  color: #fff;
}

.val6 {
  margin-bottom: 5px;
  background-color: rgba(112,110,110,0.65);
  color: #fff;
}

.status-container {
  padding-top: 20px; /* 增加内边距 */
  background-color: #f5f5f5; /* 背景色 */
  border-bottom: 1px solid #ddd; /* 底部边框 */
  position: sticky; /* 固定在页面顶部 */
  top: 0; /* 距离顶部为 0 */
  z-index: 100; /* 确保在最上层 */
}

.status-item {
  display: flex;
  align-items: center;
  margin-right: 30px; /* 增加间距 */
}

.color-block {
  display: inline-block;
  width: 100%; /* 色块宽度 */
  height: 30px; /* 色块高度 */
  border-radius: 6px; /* 圆角 */
}

.processed {
  background-color: rgba(13, 213, 46, 0.55); /* 绿色 */
}

.pending {
  background-color: #EA9C0BBA; /* 橙色 */
}

.expired {
  background-color: #FC02029D; /* 红色 */
}

.unclaimed {
  background-color: rgba(220, 216, 14, 0.71); /* 黄色 */
}

.abort {
  background-color: rgba(112,110,110,0.65);/* 灰色 */
}

.status-text {
  font-size: 18px; /* 文字更大 */
  font-weight: bold; /* 文字加粗 */
  color: #333; /* 文字颜色 */
  width: 80%; /* 文字宽度与色块一致 */
  text-align: left; /* 文字居中 */
  margin-left: 10px;
}

</style>